import { createReducer } from '@reduxjs/toolkit';
import { setCurrentPlayingVideoId, updateStartPlaybackFrom } from 'redux/actions/video';
import { initialRootState } from '.';

export default createReducer(initialRootState, builder => {
  builder
    .addCase(setCurrentPlayingVideoId, (state, action) => {
      state.app.currentPlayingVideoPlayerId = action.payload;
    })
    .addCase(updateStartPlaybackFrom, (state, action) => {
      if (state.models.lectureVideos[action.payload.videoId]) {
        state.models.lectureVideos[action.payload.videoId].startPlaybackFrom = action.payload.startPlaybackFrom;
      }
    });
});
